import { RootState } from "../../../../../redux/store";

export const vehicleModelsLoading = (state: RootState) => state.vehicleModels.itemsLoading;
export const vehicleModelActionLoading = (state: RootState) => state.vehicleModels.actionsLoading;
export const dropDownLoading = (state: RootState) => state.vehicleModels.dropDownLoading;

export const vehicleModels = (state: RootState) => state.vehicleModels.items;
export const vehicleModelsCount = (state: RootState) => state.vehicleModels.itemsCount;
export const vehicleModelForEdit = (state: RootState) => state.vehicleModels.itemForEdit;
export const dropDownValues = (state: RootState) => state.vehicleModels.dropDownItems;

export const error = (state: RootState) => state.vehicleModels.error;
export const errorAction = (state: RootState) => state.vehicleModels.errorAction;
export const dropDownError = (state: RootState) => state.vehicleModels.dropDownError;

export const validationErrors = (state: RootState) => state.vehicleModels.validationErrors;

export const filters = (state: RootState) => state.vehicleModels.filters;
